import $$api from 'models/api';

import { Document } from 'types/zod/document';

const DocumentDownloadService = {
    // Entry point for download, internals can be switched to downloadDocx if necessary.
    download: async (id: Document['document_id']): Promise<void> => {
        return DocumentDownloadService.downloadPdf(id);
    },

    downloadDocx: async (id: Document['document_id']): Promise<void> => {
        await $$api.documents.downloadDocumentFx({ path: `/documents/${id}/docx-with-name` });
    },

    downloadPdf: async (id: Document['document_id']): Promise<void> => {
        await $$api.documents.downloadDocumentFx({ path: `/documents/${id}/pdf-with-name` });
    },

    downloadZip: async (id: Document['document_id'], forAdmin = false): Promise<void> => {
        const tz = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
        await $$api.documents.downloadDocumentFx({
            path: `/documents/${id}/pdf-with-name?zip=true&tz=${tz}&forAdmin=${forAdmin}`,
        });
    },

    downloadDocxZip: async (id: Document['document_id'], forAdmin = false): Promise<void> => {
        const tz = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
        await $$api.documents.downloadDocumentFx({
            path: `/documents/${id}/docx-with-name?zip=true&tz=${tz}&forAdmin=${forAdmin}`,
        });
    },

    downloadJson: async (id: Document['document_id']): Promise<void> => {
        await $$api.documents.downloadDocumentFx({ path: `/documents/${id}/download-json` });
    },

    downloadDocxForAdmin: async (documentType: string): Promise<void> => {
        await $$api.documents.downloadDocumentFx({ path: `/admin/documents/docx?type=${documentType}` });
    },

    downloadPdfForAdmin: async (documentType: string): Promise<void> => {
        await $$api.documents.downloadDocumentFx({ path: `/admin/documents/pdf?type=${documentType}` });
    },

    downloadForReview: async (id: Document['document_id']): Promise<void> => {
        const tz = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
        await $$api.documents.downloadDocumentFx({
            path: `/admin/documents/${id}/for-review?tz=${tz}`,
        });
    },
};

export default DocumentDownloadService;
